import widgetLoader, { WidgetParams } from 'dibs-widget-loader';
import { getBuyerId } from 'dibs-cookie-jar';

export function loadSocialNetworks({ relayEnvironment }: WidgetParams): Promise<$TSFixMe> {
    const hasUserId = !!getBuyerId(document.cookie);

    if (!hasUserId) {
        return Promise.all([
            widgetLoader.load('google', { relayEnvironment }),
            widgetLoader.load('facebook', { relayEnvironment }),
            widgetLoader.load('apple', { relayEnvironment }),
        ]);
    }

    return Promise.resolve();
}
